// extracted by mini-css-extract-plugin
export default {"socialLinks":"styles_socialLinks__+98BQ","socialLinksItem":"styles_socialLinksItem__cKAWB","column":"styles_column__dg2Di"};